import Emitter from "./Emitter";

export default class CloseGame extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ "event": "showHome" });
    }

    IGT_handler() {
        this.emitParent({"event": "showHome"});
    }

    NSOFT_handler() {
        if (!this.gb.historyBackOnce && this.gb.queryParams && this.gb.queryParams.numberOfHistoryBack) {
            this.gb.historyBackOnce = true;
            if (typeof this.gb.queryParams.numberOfHistoryBack !== 'number') {
                this.gb.queryParams.numberOfHistoryBack = parseInt(this.gb.queryParams.numberOfHistoryBack);
            }
            // history back is used for mobile web view
            window.history.go(this.gb.queryParams.numberOfHistoryBack);
            // emitting to parent is used to go back to lobby on android app
            window.parent.postMessage("closeGame", "*");
        } else if (!this.gb.historyBackOnce) {
            this.gb.historyBackOnce = true;
            window.parent.postMessage("closeGame", "*");
            logger.debug(`Emitting to NSOFT WEB (to parent) closeGame`);
        }
    }

    MGS_handler() {
        this.emitParent('{"Name" : "close_application", "Origin" : "embeddedgame"}');
    }

    SPINGAMES_handler() {
        if (this.gb.queryParams.lobbyUrl !== undefined &&
            this.gb.queryParams.lobbyUrl !== 'LOBBY_URL' &&
            this.gb.queryParams.lobbyUrl !== 'DUMMY' &&
            this.gb.queryParams.lobbyUrl !== 'OFF' &&
            this.gb.queryParams.lobbyUrl !== 'WCLOSE') {

            if (this.gb.queryParams.lobbyUrlTarget && this.gb.queryParams.lobbyUrlTarget === "GAME_WINDOW") {
                window.location.href = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            } else {
                window.top.location = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            }
        } else {
            this.emitTop( { wpgaction :"close.parent" })
            this.emitTop( { event :"close.parent" })
            this.emitTop( { event :"lobby" })
        }
    }

    BWIN_handler() {
        this.emitParent("error")
        this.emitTop("error")
    }

    GAMEIOM_handler() {
        this.emitParent(JSON.stringify({ wrapperAction:"exitGame" }));
        this.emitTop("GAME_CLOSED");
    }

    PLAYTECH_handler(payload) {
        let data;

        if (payload && payload.type === 'w2gCloseGameRequest' && this.gb.ptResFeat && this.gb.ptResFeat.includes('closegame')) {
            data = {_type: "ucip.closegame.g2wCloseGameResponse"}
        } else {
            data = {_type: "ucip.basic.g2wCloseGameFrameCommand"}
        }

        if (!this.gb.alreadySent) {
            this.gb.alreadySent = true;
            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
            } else {
                this.emitParent(JSON.stringify(data));
            }
        }

        if (this.gb.queryParams.lobbyUrl !== undefined &&
            this.gb.queryParams.lobbyUrl !== 'LOBBY_URL' &&
            this.gb.queryParams.lobbyUrl !== 'DUMMY' &&
            this.gb.queryParams.lobbyUrl !== 'OFF' &&
            this.gb.queryParams.lobbyUrl !== 'WCLOSE') {

            if (this.gb.queryParams.lobbyUrlTarget && this.gb.queryParams.lobbyUrlTarget === "GAME_WINDOW") {
                window.location.href = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            } else {
                window.top.location = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            }
        }
    }

    POKERSTARS_handler(data) {
        if (data && data.payload && data.payload.code && data.payload.code === 'INACTIVITY_TIMEOUT') {
            const dataForXc = {"msgId":"rg2xcErrorOccurred", "error":"sessionExpiredError"};

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            }
        } else if (this.gb.queryParams.lobbyUrl !== undefined &&
            this.gb.queryParams.lobbyUrl !== 'LOBBY_URL' &&
            this.gb.queryParams.lobbyUrl !== 'DUMMY' &&
            this.gb.queryParams.lobbyUrl !== 'OFF' &&
            this.gb.queryParams.lobbyUrl !== 'WCLOSE') {

            if (this.gb.queryParams.lobbyUrlTarget && this.gb.queryParams.lobbyUrlTarget === "GAME_WINDOW") {
                window.location.href = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            } else {
                window.top.location = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            }
        } else if (this.gb.queryParams.lobbyUrl !== undefined && this.gb.queryParams.lobbyUrl === 'WCLOSE') {
            window.close();
        } else if (this.gb.utils.isIframe === true) {
            this.emitParent({ message: "close", param: null});
            this.emitTop({ wpgaction: "close" });
            this.emitParent({ wpgaction: "close.parent" });
        } else {
            if (!this.gb.historyBackOnce && this.gb.queryParams.numberOfHistoryBack) {
                if (typeof this.gb.queryParams.numberOfHistoryBack !== 'number') {
                    this.gb.queryParams.numberOfHistoryBack = parseInt(this.gb.queryParams.numberOfHistoryBack);
                }

                this.gb.historyBackOnce = true;
                window.history.go(this.gb.queryParams.numberOfHistoryBack);

            } else if (!this.gb.historyBackOnce) {
                this.gb.historyBackOnce = true;
                window.history.back();
            }
        }
    }

    _default() {
        // Native close method
        if (this.gb.settings && this.gb.settings.nativeFunction) {
            if (this.gb.settings.nativeFunction === 'betnation' && window.flutter) {
                window.flutter.postMessage('CLOSE_GAME');
                return
            } 
        } 
        
        if (this.gb.queryParams.lobbyUrl !== undefined &&
            this.gb.queryParams.lobbyUrl !== 'LOBBY_URL' &&
            this.gb.queryParams.lobbyUrl !== 'DUMMY' &&
            this.gb.queryParams.lobbyUrl !== 'OFF' &&
            this.gb.queryParams.lobbyUrl !== 'WCLOSE') {
            if (this.gb.queryParams.lobbyUrlTarget && this.gb.queryParams.lobbyUrlTarget === "GAME_WINDOW") {
                window.location.href = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            } else {
                window.top.location = decodeURIComponent(this.gb.queryParams.lobbyUrl);
            }
        } else if (this.gb.queryParams.lobbyUrl !== undefined && this.gb.queryParams.lobbyUrl === 'WCLOSE') {
            window.close();
        } else if (this.gb.utils.isIframe === true) {
            this.emitParent({ message: "close", param: null});
            this.emitTop({ wpgaction: "close" });
            this.emitParent({ wpgaction: "close.parent" });
        } else {
            if (!this.gb.historyBackOnce && this.gb.queryParams.numberOfHistoryBack) {
                if (typeof this.gb.queryParams.numberOfHistoryBack !== 'number') {
                    this.gb.queryParams.numberOfHistoryBack = parseInt(this.gb.queryParams.numberOfHistoryBack);
                }

                this.gb.historyBackOnce = true;
                window.history.go(this.gb.queryParams.numberOfHistoryBack);

            } else if (!this.gb.historyBackOnce) {
                this.gb.historyBackOnce = true;
                window.history.back();
            }
        }
    }
}
